import { NgModule } from '@angular/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BusquedaFuncionarioComponent } from './busqueda-funcionario.component';
import { BusquedaFuncionarioRoutingModule } from './busqueda-funcionario.routing.module';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/formulario/', '.json');
}

@NgModule({
    declarations: [BusquedaFuncionarioComponent],
    imports: [
        FormsModule, ReactiveFormsModule,
        BusquedaFuncionarioRoutingModule,
        SharedModule,
        CommonModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            isolate: true
        })
    ],
    entryComponents: []
})

export class BusquedaFuncionarioModule { }